import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/sw/.claude/worktrees/agent-a866b728a7fc91b23/apps/buywisely/app/components/NotFoundView.tsx");
